/*
  Helper used to go through a collection of URLS separate for each service
  and return the concatenated version of the BASE_URL with the endpoints
  preserving type safety
*/
export const getURLS = <T>(baseUrl: string, endpoints: { [x: string]: string }): T =>
  (Object.keys(endpoints).reduce(
    (
      acc: {
        [x: string]: string;
      },
      item: string,
    ) => ({
      ...acc,
      [item]: baseUrl + endpoints[item],
    }),
    {},
  ) as unknown) as T;

export const routeReplacer = (string: string, data: Record<string, string | number>) =>
  Object.keys(data).reduce((str, item) => str.replace(`:${item}`, data[item]?.toString()), string);

export const buildQueryString = (searchData: Record<string, string | number | boolean | any>) => {
  const str = [];
  for (const p in searchData) {
    if (searchData.hasOwnProperty(p) && typeof searchData[p] !== 'object') {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(searchData[p])}`);
    } else if (searchData[p] !== null && searchData[p].length > 0) {
      str.push(parameterizeArray(p, searchData[p]));
    }
  }
  return str.join('&');
};

export const createQueriedURL = (
  baseUrl: string,
  query: Record<string, string | number | boolean | any>,
) => {
  if (query) {
    // Templating to get the question mark in there to make a valid query URL
    return `${baseUrl}?${buildQueryString(query)}`;
  }
  return baseUrl;
};

export const parameterizeArray = (key: string, arr: any[]) => {
  arr = arr.map(encodeURIComponent); // eslint-disable-line
  const encodedArray = arr.join(`&${key}=`);
  return `${key}=${encodedArray}`;
};

// Receives any object as a parameter, with the keymappers select the keys that will be merged concatenateed with the separator
export const stringObjectConcat = (
  object: { [key: string]: string },
  keyMappers: string[],
  separator = ' ',
) => {
  if (!object) {
    return '';
  }
  const strings = keyMappers.reduce((acc: string[], item: string) => [...acc, object[item]], []);

  return strings.join().replace(/,/g, separator);
};

export const getInitials = (firstName?: string, lastName?: string) => {
  const firstInital = `${firstName}`.substr(0, 1);
  let initials = '';
  if (lastName) {
    const lastInitial = `${lastName}`.substr(0, 1);
    initials = `${firstInital}${lastInitial}`;
  } else {
    initials = `${firstInital}`;
  }
  return initials.toUpperCase();
};
